

/* eslint angular/angularelement: 0 */

define(['jquery', 'angular', 'squid/index'], function ($, angular, squid) {
    return squid.module('xo-shopping-cart.ui', []).directive('onEllipsis', function ($timeout, $parse, $window) {
        // if an element has an ellipsis text-overflow in effect (it must already have
        // the appropriate css styling) then invoke the function that is passed to the directive
        function getVisibleWidth(elem) {
            // cross browser, returns decimals for ultra-precision
            return elem.getBoundingClientRect().right - elem.getBoundingClientRect().left;
        }

        function getNaturalWidth(elem) {
            var old = {
                overflow: elem.style.overflow,
                width: elem.style.width,
                display: elem.style.display
            };
            var result;

            elem.style.overflow = 'visible';
            elem.style.width = 'auto';
            elem.style.display = 'inline-block';
            result = getVisibleWidth(elem);
            elem.style.overflow = old.overflow;
            elem.style.width = old.width;
            elem.style.display = old.display;

            return result;
        }

        function getStyle(elem, style) {
            if ($window.getComputedStyle) {
                return $window.getComputedStyle(elem)[style]; // modern browsers
            }

            return elem.currentStyle[style]; // IE
        }

        function hasEllipsis(elem) {
            var isOverflowHidden = getStyle(elem, 'overflow') === 'hidden';
            var isTextOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
            var isWhiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';

            if (isOverflowHidden && isTextOverflowEllipsis && isWhiteSpaceNowrap) {
                return getVisibleWidth(elem) < getNaturalWidth(elem);
            }

            return false;
        }

        return {
            restrict: 'A',
            link: function link(scope, element, attrs) {
                function invokeSubscriber() {
                    $parse(attrs.onEllipsis)(scope);
                    scope.$apply();
                }

                $timeout(function () {
                    if (hasEllipsis(element[0])) {
                        invokeSubscriber();
                    }
                });
            }
        };
    }).directive('dynamicMaxheight', function ($timeout, $parse) {
        // Makes an element examine the outerHeight of its siblings
        // and the max-height of its parent, then sets a max-height for itself
        // so that everything fits within the limits of the parent. Note that it assumes
        // no other sibling also has dynamic-maxheight.
        return {
            restrict: 'A',
            link: function link(scope, element, attrs) {
                function resizeContainer() {
                    var $element = $(element);
                    var parentHeight = parseFloat($element.parent().css('max-height'));
                    var siblings = $element.siblings().filter(function () {
                        var pos = $(this).css('position');
                        return pos !== 'fixed' && pos !== 'absolute';
                    }).map(function getOuterHeights() {
                        return $(this).outerHeight();
                    });
                    var siblingsHeight = 0;
                    var i;

                    for (i = 0; i < siblings.length; i += 1) {
                        siblingsHeight += siblings[i];
                    }

                    var spaceAvailable = parentHeight - siblingsHeight;

                    if (!isNaN(spaceAvailable)) {
                        $element.css('max-height', spaceAvailable + 'px');
                    }
                }

                // if an expression is provided, it is used as an event to listen for and recalculate the height
                if (attrs.dynamicMaxheight) {
                    scope.$on($parse(attrs.dynamicMaxheight)(scope), resizeContainer);
                }

                $timeout(resizeContainer);
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shoppingcart/lib/ui.js
// module id = ./pages/xo-shoppingcart/lib/ui.js
// module chunks = 0